module.exports = __webpack_public_path__ + "img/shofar_yes.fa641d35.png";